import { SelectComponent, SelectItemViewModel, FieldComponent, FieldContainerComponent } from "shared/ui-kit";

import { MapCorrelationSettings, MapCorrelationsMode, MapCorrelationsCurrency } from '../model';

export interface MapCorrelationsSettingsProps {
	settings: MapCorrelationSettings;
	setSettings: (newSettings: MapCorrelationSettings) => void;
}

const currencyItems: SelectItemViewModel[] = [
	{ key: MapCorrelationsCurrency.RUB, text: "RUB" },
	{ key: MapCorrelationsCurrency.USD, text: "USD" }
];
const modeItems: SelectItemViewModel[] = [
	{ key: MapCorrelationsMode.CORRELATION, text: "Корреляция" },
	{ key: MapCorrelationsMode.SIMILARITY, text: "Схожесть" }
];

export const MapCorrelationsSettings = (props: MapCorrelationsSettingsProps) => {
	return (
		<FieldContainerComponent className="default-settings-paddings">
			<FieldComponent title="Валюта">
				<SelectComponent
					items={currencyItems}
					selectedKey={props.settings.currency}
					onSelectedItemChanged={item => props.setSettings({ ...props.settings, currency: item.key as MapCorrelationsCurrency })} />
			</FieldComponent>
			<FieldComponent title="Параметр">
				<SelectComponent
					items={modeItems}
					selectedKey={props.settings.mode}
					onSelectedItemChanged={item => props.setSettings({ ...props.settings, mode: item.key as MapCorrelationsMode })} />
			</FieldComponent>
		</FieldContainerComponent>
	);
}